import { render, staticRenderFns } from "./SignInformation.vue?vue&type=template&id=74699b92&scoped=true"
import script from "./SignInformation.vue?vue&type=script&lang=js"
export * from "./SignInformation.vue?vue&type=script&lang=js"
import style0 from "./SignInformation.vue?vue&type=style&index=0&id=74699b92&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74699b92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74699b92')) {
      api.createRecord('74699b92', component.options)
    } else {
      api.reload('74699b92', component.options)
    }
    module.hot.accept("./SignInformation.vue?vue&type=template&id=74699b92&scoped=true", function () {
      api.rerender('74699b92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/logisticsOrders/components/detailBox/components/SignInformation.vue"
export default component.exports